import PropTypes from "prop-types";
import DonutChart from "./Elements/DonutChart";
import LineChart from "./Elements/LineChart";
import TextDisplay from "./Elements/TopElementText";
import TextRows from "./Elements/TextRows";

import { useFetchPartitionData } from "../fetch-data/FetchPartitionData";
import { useDonutData } from "../hooks/useDonutData"; 
import { useNumberOfAssets } from "../hooks/useNumberOfAssets";
import { useLineChartData } from "../hooks/useLineChartData";
import { useCurrentYearValues } from "../hooks/useCurrentYearValues";

const SmallMultiple = ({ location_key, energySource, category, unit, smallMultipleType, donutSpec, LineChartTitle, textData, colors }) => {
  // Fetch raw data and handle errors
  const { rawData, loading, error } = useFetchPartitionData(location_key, energySource, category, smallMultipleType);

  // Process data using hooks
  const { data: numberOfAssets, loading: numberOfAssetsLoading, error: assetsError } = useNumberOfAssets(rawData, energySource, category);
  const { data: donutData, loading: donutDataLoading, error: processingError } = useDonutData(rawData, energySource, category, donutSpec);
  const { data: lineData, loading: lineLoading, error: lineError } = useLineChartData(rawData, energySource, category);
  const { data: rowData, loading: currentYearLoading, error: rowError } = useCurrentYearValues(rawData, energySource, category, unit);

  if (loading || donutDataLoading || numberOfAssetsLoading || lineLoading || currentYearLoading) {return <div>Daten werden geladen...</div>;}

  // Combine all errors for unified error handling
  const errors = [error, assetsError, lineError, rowError, processingError].filter(Boolean);

  if (errors.length > 0) {
    return (
      <div>
        Fehler beim Laden der Daten:
        <ul>
          {errors.map((err, index) => (
            <li key={index}>{err.message}</li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div className="small-multiple flex flex-col items-center border p-5 rounded-lg">
      <TextDisplay 
        text={textData?.summary || "Keine Zusammenfassung verfügbar"}
        popoverText={textData?.popoverText || "Keine Erklärung verfügbar"}
        numberOfAssets={numberOfAssets || 0}
      />
      {/* Wrapper for DonutChart and LineChart */}
      <div className="flex flex-col items-center">
        <DonutChart
          hookData={donutData} // use data from hook useDonutChartData
          colors={colors || ["#ffcd00", "#E0E0E0"]}
          unit = {unit}
        />
        <div className="mt-4 w-full flex justify-center">
          <div className="scale-90 origin-top max-w-[200px]">
            <LineChart 
              data={lineData || []} 
              color={colors || ["#ffcd00", "#E0E0E0"]}
              title={LineChartTitle || []}
              unit={unit}
            />
          </div>
        </div>
      </div>
      <TextRows 
        rows={rowData || []} 
      />
    </div>
  );
};

SmallMultiple.propTypes = {
  title: PropTypes.string,
  donutData: PropTypes.array,
  lineData: PropTypes.array,
  textData: PropTypes.shape({
    summary: PropTypes.string,
    numberOfAssets: PropTypes.number,
    totalPower: PropTypes.number,
    rows: PropTypes.arrayOf(PropTypes.string),
  }),
  colors: PropTypes.arrayOf(PropTypes.string),
};

export default SmallMultiple;